<template>
  <div class="dialog__buttons">
    <button class="dialog__button dialog__button-cancel" @click="closeDialog">
      Cancel
    </button>
    <button
      class="dialog__button dialog__button-save"
      :disabled="disabledOkay"
      @click="clickPositive"
    >
      {{ textPositive }}
    </button>
  </div>
</template>

<script>
export default {
  name: "OptionsButtons",
  props: {
    textPositive: {
      type: String,
      default: null,
    },
    disabledOkay: {
      type: Boolean,
      default: null,
    },
  },
  methods: {
    clickPositive() {
      this.$emit("pushedPositive");
    },
    closeDialog() {
      this.$store.commit("Dialog/setData", {
        label: "baseDialogOpen",
        data: false,
      });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.dialog {
  &__buttons {
    display: flex;
    justify-content: flex-end;
  }
  &__button {
    background: transparent;
    border: none;
    font-size: 1.6rem;
    font-weight: 600;
    transition: 0.3s ease-out;
    padding: 0.5rem 1rem;
    border-radius: 0.4rem;
    &:hover {
      background: $red;
      color: $white !important;
    }
    &-cancel {
      color: $gray;
    }
    &-save {
      color: $red;
      margin-left: 1.5rem;
      &[disabled="disabled"] {
        cursor: not-allowed;
        &:hover {
          background: $gray;
          color: $white !important;
        }
      }
    }
  }
}
</style>
